<template>
  <div class="page">
    <!-- 侧边设备列表 -->
    <div class="tab" :style="{ left: drawer ? '324px' : '0px' }">
      <div class="sidebar-wrapper" v-if="heddinList">
        <!-- 列表头部：搜索与筛选控制 -->
        <div class="list-header-tools">
          <ul class="tab-list">
            <li
              :class="{ active: radio1 === '1' }"
              @click="handleTabChange('1')"
            >
              <span>我的</span>
            </li>
            <li
              :class="{ active: radio1 === '0' }"
              @click="handleTabChange('0')"
            >
              <span>全部</span>
            </li>
          </ul>

          <div class="filter-controls">
            <el-input
              size="mini"
              placeholder="搜索站点名称"
              v-model="device_name"
              prefix-icon="el-icon-search"
              clearable
              class="filter-item"
              @change="refreshList"
              @clear="refreshList"
            />
            <el-form class="filter-row" inline label-width="20px">
              <el-form-item label="型号">
                <el-select
                  size="mini"
                  v-model="filterType"
                  placeholder="设备类型"
                  clearable
                  class="filter-select"
                  @change="refreshList"
                >
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="type in deviceTypeList"
                    :key="type"
                    :label="type"
                    :value="type"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select
                  size="mini"
                  v-model="filterStatus"
                  placeholder="在线状态"
                  clearable
                  class="filter-select"
                  @change="refreshList"
                >
                  <el-option label="全部" value="" />
                  <el-option label="在线" value="1" />
                  <el-option label="离线" value="0" />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 列表内容区 -->
        <div class="list-content">
          <recycle-scroller
            v-if="filteredData.length > 0"
            class="scroller"
            :items="filteredData"
            :item-size="112"
            key-field="id"
            :emitUpdate="true"
            @update="handleScrollerUpdate"
            v-slot="{ item }"
          >
            <div
              class="list_item"
              :class="{ offline: item.status === '0' }"
              @click="listItemClickHandler(item)"
            >
              <div class="item-header">
                <div class="single-line device-name" :title="item.deviceName">
                  {{ item.deviceName }}
                </div>
                <div class="follow-action" @click.stop="toggleFollow(item)">
                  <i
                    class="icon"
                    :class="item.isFollow ? 'follow-icon' : 'unfollow-icon'"
                    :style="{ color: item.isFollow ? '#f7ba2a' : '#ccc' }"
                  ></i>
                  <i class="count">
                    {{ formatFollowCount(followCounts[item.device]) }}</i
                  >
                </div>
              </div>
              <div class="device-meta">{{ item.deviceType }}</div>
              <div class="single-line address-box" :title="item.siteOwner">
                <span>站主:</span>
                <span>{{ item.siteOwner || "暂无" }}</span>
              </div>
              <div class="single-line item-footer">
                <div
                  :class="item.status === '1' ? 'dot_online' : 'dot_offline'"
                ></div>
                <span>更新时间 {{ item.lastUploadTime || "无" }}</span>
              </div>
            </div>
          </recycle-scroller>
          <div v-else class="no-data">暂无匹配站点</div>
        </div>
      </div>
    </div>

    <!-- 侧边栏折叠按钮 -->
    <div
      class="show_icon"
      :style="{ left: getLeft() }"
      @click="heddinList = !heddinList"
    >
      <img
        :src="
          heddinList
            ? require('@/assets/homeIcon/hidden.png')
            : require('@/assets/homeIcon/show.png')
        "
      />
    </div>

    <!-- 要素切换按钮 -->
    <div class="data_list">
      <div
        class="item"
        v-for="(item, index) in icons"
        :key="index"
        @click="handleIconClick(item, index)"
        v-hasPermi="[item.permi]"
        :class="{ selected: activeIndex === index }"
      >
        <img
          class="icon"
          :src="activeIndex === index ? item.activeUrl : item.url"
        />
        <p class="name">{{ item.name }}</p>
      </div>
    </div>

    <!-- 设备详情抽屉 -->
    <el-drawer
      ref="drawer"
      :visible.sync="drawer"
      :size="324"
      direction="ltr"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :modal="false"
      :with-header="false"
      class="details"
    >
      <div class="mainlist" v-if="deviceData.device">
        <div class="header">
          <i class="close" @click="clDrawer">X</i>
          <div
            class="butt"
            :class="{
              is4g: deviceData.deviceType === '4G气象站',
              offline: deviceData.status === '0',
              online: deviceData.status === '1',
            }"
          >
            <h1 class="title">
              {{ deviceData.deviceName }}
              <span v-if="deviceData.status === '0'">(离线)</span>
            </h1>
            <h2 class="subtitle">{{ deviceData.deviceType }}</h2>
            <p>
              纬度:{{ deviceData.positionLat }}, 经度:{{
                deviceData.positionLng
              }}
            </p>
          </div>
        </div>
        <div class="info" :class="{ online: deviceData.status === '1' }">
          <div class="update-time">
            <div>本次数据更新时间</div>
            <div>{{ deviceData.newTime }} {{ deviceData.week }}</div>
          </div>
          <div class="wendu">
            <p>{{ deviceData.tempOut || "--" }}°C</p>
          </div>
          <div class="more-info" @click="choseDetails">
            点击查看站点更多信息>
          </div>
        </div>
        <div class="datalist">
          <div class="postlist" v-for="(group, gIdx) in dataGroups" :key="gIdx">
            <div v-for="(cell, cIdx) in group" :key="cIdx" class="item">
              <img class="icon" :src="cell.icon" />
              <span class="val"
                >{{ deviceData[cell.key] ?? "--" }}{{ cell.unit }}</span
              >
              <span class="name">{{ cell.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 图例 -->
    <div class="sebiao" v-if="showLegend">
      <div class="sebiao-header">
        <div class="sebiao-title">{{ currentLegendLabel }}</div>
      </div>
      <div class="sebiao-body">
        <div
          v-for="(item, index) in currentLegendColors"
          :key="index"
          class="sebiao-item"
        >
          <div :style="{ backgroundColor: item.color }" class="color-bar"></div>
          <div class="scope-text">{{ item.scope }}</div>
        </div>
      </div>
    </div>

    <!-- 地图 -->
    <l-map
      ref="map"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%; width: 100%"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @ready="onMapReady"
    >
      <l-tile-layer :url="tileUrl" :attribution="attribution" />
      <l-tile-layer :url="tileUrl2" :attribution="attribution" />
      <l-control-zoom position="bottomright" />
      <v-locatecontrol :options="locateOptions" />
      <l-control-scale position="bottomleft" :imperial="false" :metric="true" />

      <l-marker
        v-for="marker in markers"
        :key="marker.id"
        :lat-lng="marker.position"
        :z-index-offset="marker.zIndex"
        @click="markerClickHandler(marker)"
      >
        <l-icon
          :icon-size="[64, 22]"
          :icon-anchor="[32, 22]"
          :class-name="
            marker.status === '1'
              ? 'custom-div-marker online'
              : 'custom-div-marker offline'
          "
        >
          <div v-html="marker.content"></div>
        </l-icon>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LControlScale,
  LControlZoom,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Vue2LeafletLocatecontrol from "vue2-leaflet-locatecontrol";
import { mapState } from "vuex";
import { $device } from "@/services";
import { windDegreeToDir } from "@/utils/wind";
import { tem, rhu, pre, wind, sun } from "@/utils/colorLevel.js";

const ELEMENT_MAP = [
  "tempOut",
  "humidityOut",
  "windSpeed",
  "windDir",
  "hourRain",
  "dayRain",
  "solarRadiation",
  "uv",
];

export default {
  name: "GIS",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControlScale,
    LControlZoom,
    "v-locatecontrol": Vue2LeafletLocatecontrol,
  },
  data() {
    return {
      tileUrl:
        "http://t7.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=3136d42f15afdd53a7cfc2c26edc9b18",
      tileUrl2:
        "http://t7.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=3136d42f15afdd53a7cfc2c26edc9b18",
      attribution: "&copy; 高德地图",
      center: [39.9, 116.4],
      zoom: 10,
      mapOptions: {
        minZoom: 4,
        maxZoom: 18,
        zoomControl: false,
        attributionControl: false,
      },
      locateOptions: {
        showCompass: true,
        drawCircle: true,
        position: "bottomright",
        icon: "el-icon-location",
      },

      radio1: "0",
      drawer: false,
      heddinList: false,
      activeIndex: 0,

      // 筛选条件
      device_name: "",
      filterType: "",
      filterStatus: "1",
      onlyFollowed: false,
      deviceTypeList: [],

      listAllData: [], // 【新增】专门用于侧边栏列表的数据（全量）
      mapData: [], // 【新增】专门用于地图渲染的数据（根据视口获取）
      markers: [],
      deviceData: {},
      mapInstance: null,
      icons: this.initIcons(),
      dataGroups: [
        [
          {
            icon: require("../../assets/gis/outdoor-temperature.png"),
            key: "tempOut",
            label: "室外温度",
            unit: "℃",
          },
          {
            icon: require("../../assets/gis/outdoor-humidity.png"),
            key: "humidityOut",
            label: "室外湿度",
            unit: "%",
          },
        ],
        [
          {
            icon: require("../../assets/gis/wind.png"),
            key: "windSpeed",
            label: "平均风速(2分钟)",
            unit: "m/s",
          },
          {
            icon: require("../../assets/gis/wind.png"),
            key: "hpaAbs",
            label: "气压值",
            unit: "hPa",
          },
        ],
        [
          {
            icon: require("../../assets/gis/rain.png"),
            key: "hourRain",
            label: "小时降雨量(距整点)",
            unit: "mm",
          },
          {
            icon: require("../../assets/gis/hpa.png"),
            key: "windDir",
            label: "平均风向(2分钟)",
            unit: "",
          },
        ],
        [
          {
            icon: require("../../assets/gis/indoor_tem.png"),
            key: "tempIn",
            label: "室内温度",
            unit: "℃",
          },
          {
            icon: require("../../assets/gis/indoor_hum.png"),
            key: "humidityIn",
            label: "室内湿度",
            unit: "%",
          },
        ],
        [
          {
            icon: require("../../assets/gis/uv.png"),
            key: "uv",
            label: "UV(紫外线强度)",
            unit: "",
          },
          {
            icon: require("../../assets/gis/sun.png"),
            key: "solarRadiation",
            label: "光照强度",
            unit: "W/㎡",
          },
        ],
      ],
      timer: null,
      drawerDeviceId: null,
      followCounts: {},
      scrollerTimer: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    // 统一的数据源过滤，供列表和地图同时使用
    filteredData() {
      let result = [...this.listAllData];
      // 仅看关注
      if (this.onlyFollowed) {
        result = result.filter((i) => i.isFollow);
      }
      return result.sort((a, b) => b.status - a.status);
    },
    activeElementConfig() {
      return this.icons[this.activeIndex] || {};
    },
    showLegend() {
      const colors = this.activeElementConfig.legendColors;
      return Array.isArray(colors) && colors.length > 0;
    },
    // 当前图例标题
    currentLegendLabel() {
      return this.activeElementConfig.legendLabel || "";
    },
    // 当前图例色卡数组
    currentLegendColors() {
      return this.activeElementConfig.legendColors || [];
    },
  },
  async created() {
    await this.getTypeList();
    this.refreshList(); // 页面加载时初始化列表数据
    this.refreshMap(); // 页面加载时初始化地图数据
    this.timer = setInterval(this.refreshList, 30000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    windDegreeToDir,
    onMapReady(map) {
      this.mapInstance = map;
      let mapMoveTimer = null;
      const debouncedRefresh = () => {
        clearTimeout(mapMoveTimer);
        mapMoveTimer = setTimeout(() => {
          this.refreshMap();
        }, 400);
      };
      map.on("moveend", debouncedRefresh);
      map.on("zoomend", debouncedRefresh);

      // 首次加载自动请求
      this.refreshMap();
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    handleTabChange(val) {
      if (this.radio1 === val) return;
      this.radio1 = val;
      this.refreshList();
    },
    formatFollowCount(count) {
      if (count === undefined || count === null || count === 0) return "";
      return count >= 1000 ? "999+" : count;
    },
    handleScrollerUpdate(startIndex, endIndex) {
      if (this.scrollerTimer) clearTimeout(this.scrollerTimer);

      this.scrollerTimer = setTimeout(() => {
        const visibleItems = this.filteredData.slice(startIndex, endIndex + 1);
        const targetIds = visibleItems.map((item) => item.device);

        if (targetIds.length > 0) {
          this.fetchFollowCountsBatch(targetIds.join(","));
        }
      }, 500);
    },

    async fetchFollowCountsBatch(deviceIdsStr) {
      try {
        const res = await $device.getDevicesFollowCount(deviceIdsStr);
        if (res.success) {
          const newData = res.data || {};
          const requestedIds = deviceIdsStr.split(",");

          // 创建现有数据的副本
          const updatedCounts = { ...this.followCounts };

          // 遍历本次请求的所有 ID
          requestedIds.forEach((id) => {
            // 如果接口返回了该 ID 的数值则更新，否则显式设为 0 (修复空对象导致显示 1 的 Bug)
            updatedCounts[id] = newData[id] !== undefined ? newData[id] : 0;
          });

          this.followCounts = updatedCounts;
        }
      } catch (e) {
        console.error("加载关注数失败", e);
      }
    },

    async getTypeList() {
      try {
        const res = await $device.getDeviceTypeList();
        if (res.code === 200) this.deviceTypeList = res.data;
      } catch (e) {
        console.error("获取类型失败", e);
      }
    },
    // ======= 1. 列表刷新方法（侧边栏） =======
    async refreshList() {
      const user = this.userInfo;
      let params = {
        element: ELEMENT_MAP[this.activeIndex],
        keyWord: this.device_name,
        deviceType: this.filterType,
        status: this.filterStatus,
        specialUserId: user?.id,
      };
      // 列表刷新时，坚决不传入 minLng/maxLng 等边界参数，以便获取全量数据
      if (this.radio1 === "1") {
        if (!user || !user.id) return this.$message.error("请登录");
        params.userId = user.id;
      }
      try {
        const res = await $device.getDeviceDataList(params);
        if (res.code === 200) {
          this.listAllData = Object.freeze(res.data);
          // 如果抽屉当前打开的设备在此次全量列表中，尝试更新抽屉数据
          if (this.drawer && this.drawerDeviceId) {
            const target = this.listAllData.find(
              (d) => d.device === this.drawerDeviceId
            );
            if (target) this.updateDeviceDetail(target);
          }
        }
      } catch (e) {
        console.error("列表数据加载失败", e);
      }
    },

    // ======= 2. 地图刷新方法（地图可视区域） =======
    async refreshMap() {
      if (!this.mapInstance) return;
      const bounds = this.mapInstance.getBounds();
      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();

      const user = this.userInfo;
      let params = {
        element: ELEMENT_MAP[this.activeIndex],
        keyWord: this.device_name,
        deviceType: this.filterType,
        status: this.filterStatus,
        specialUserId: user?.id,
        // 【核心】只传入当前可视区域的地理边界
        minLng: sw.lng,
        maxLng: ne.lng,
        minLat: sw.lat,
        maxLat: ne.lat,
      };
      if (this.radio1 === "1") {
        if (!user || !user.id) return;
        params.userId = user.id;
      }
      try {
        const res = await $device.getNewDeviceDataList(params);
        if (res.code === 200) {
          this.mapData = Object.freeze(res.data);
          // 立即基于可视区域的数据渲染地图标记
          this.filterMarkersByViewport();
        }
      } catch (e) {
        console.error("地图数据加载失败", e);
      }
    },

    // ======= 3. 地图标记过滤渲染（使用 mapData） =======
    filterMarkersByViewport() {
      if (!this.mapInstance) return;
      const currentZoom = this.mapInstance.getZoom();

      const viewportStations = this.mapData.filter((item) => {
        if (!item.positionLat || !item.positionLng) return false;
        const lat = Number(item.positionLat);
        const lng = Number(item.positionLng);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return false;

        // 关注/我的设备、重要类型设备（Wifi/4G）强制显示
        if (item.isMy || item.isFollow) return true;
        const typeStr = (item.deviceType || "").toLowerCase();
        if (typeStr.includes("wifi") || typeStr.includes("4g")) return true;

        const level = Number(item.displayLevel) || 3;
        if (currentZoom < 7) return level === 1;
        if (currentZoom < 10) return level <= 2;
        return true;
      });

      this.updateMarkers(viewportStations.slice(0, 400));
    },

    // 关注/取关逻辑
    async toggleFollow(item) {
      const user = this.userInfo;
      if (!user || !user.id) return this.$message.warning("请先登录");
      try {
        const params = { userId: user.id, device: item.device };
        let res;
        if (item.isFollow) res = await $device.unfollowDevice(params);
        else res = await $device.followDevice(params);

        if (res.code === 200) {
          this.$message.success(item.isFollow ? "已取关" : "关注成功");
          // 本地更新状态，触发 computed 重新计算
          item.isFollow = !item.isFollow;
          // 立即更新地图标记显示
          this.filterMarkersByViewport();

          // 立即请求最新的关注人数
          this.fetchFollowCountsBatch(item.device);
        }
      } catch (e) {
        this.$message.error("操作失败");
      }
    },

    handleIconClick(item, index) {
      this.activeIndex = index;
      this.refreshList();
      this.refreshMap();
    },

    updateMarkers(renderList) {
      const currentIcon = this.icons[this.activeIndex];
      this.markers = renderList
        .filter((item) => {
          // 关键修复2：Number.isFinite 检查字符串会返回 false，会导致字符串类型的经纬度被忽略。改为以下方式：
          const lat = Number(item.positionLat);
          const lng = Number(item.positionLng);
          return !Number.isNaN(lat) && !Number.isNaN(lng);
        })
        .map((item) => {
          let val = item.value;
          const isOnline = item.status === "1";
          const isTrue = val !== null && val !== undefined;

          if (this.activeIndex === 3 && isTrue) {
            const dirMap = [
              "",
              "北",
              "东北",
              "东",
              "东南",
              "南",
              "西南",
              "西",
              "西北",
            ];
            val = dirMap[val] || "--";
          }
          if (this.activeIndex === 2 && isTrue && isOnline) val = val + "级";

          const color =
            isOnline && isTrue
              ? currentIcon.dataFunc.color(item.value)
              : "#ccc";
          const typeStr = (item.deviceType || "").toLowerCase();
          let zIndex = isOnline ? 1000 : 100;
          if (typeStr.includes("wifi") || typeStr.includes("4g"))
            zIndex += 1500;
          if (item.isMy || item.isFollow) zIndex += 3000;

          return {
            ...item,
            position: [Number(item.positionLat), Number(item.positionLng)],
            zIndex: zIndex,
            content: this.generateMarkerContent(item, val, color, isOnline),
          };
        });
    },

    generateMarkerContent(item, val, color, isOnline) {
      const typeStr = (item.deviceType || "").toLowerCase();
      let icon = require("@/assets/markers/3.png");
      if (typeStr.includes("wifi")) icon = require("@/assets/markers/wifi.png");
      else if (typeStr.includes("4g"))
        icon = require("@/assets/markers/4g.png");
      else if (typeStr.includes("s01"))
        icon = require("@/assets/markers/s1.png");

      const displayVal = isOnline ? val ?? "--" : "离线";
      let mark = item.isMy
        ? '<div class="icon my-mark"></div>'
        : item.isFollow
        ? '<div class="icon follow-mark"></div>'
        : "";

      return `
        <div class="div-marker-wrapper ${
          isOnline ? "online" : "offline"
        }" style="background-color: ${color}">
          ${mark}
          <img src="${icon}" class="marker-type-icon" />
          <span class="marker-value">${displayVal}</span>
        </div>
      `;
    },
    listItemClickHandler(item) {
      this.mapInstance.setView(
        [Number(item.positionLat), Number(item.positionLng)],
        16
      );
      this.drawerDeviceId = item.device;
      this.updateDeviceDetail(item);
      this.drawer = true;
    },
    markerClickHandler(item) {
      this.drawerDeviceId = item.device;
      this.center = [Number(item.positionLat), Number(item.positionLng)];
      this.updateDeviceDetail(item);
      this.drawer = true;
    },

    async updateDeviceDetail(item) {
      if (!item) return;
      try {
        const res = await $device.getDeviceLatestData(item.device);
        if (res.code === 200) {
          const time = res.data?.time
            ? dayjs(res.data.time + "", "YYYYMMDDHHmmss")
            : null;
          this.deviceData = {
            ...item,
            ...res.data,
            week: this.getWeek(time),
            newTime: time ? time.format("YYYY-MM-DD HH:mm:ss") : "--",
          };
        }
      } catch (e) {
        console.error(e);
      }
    },

    getColorByValue(val, levelArray) {
      if (val === null || val === undefined) return "#ccc";
      for (let i = 1; i < levelArray.length; i++) {
        let threshold = parseFloat(
          levelArray[i].scope.replace(/[^0-9.-]/g, "")
        );
        if (!isNaN(threshold) && val < threshold)
          return levelArray[i - 1].color;
      }
      return levelArray[levelArray.length - 1].color;
    },
    getWeek(v) {
      if (!v) return "";
      let w = ["日", "一", "二", "三", "四", "五", "六"];
      return "星期" + w[v.day()];
    },
    clDrawer() {
      this.drawer = false;
    },
    choseDetails() {
      this.$router.push({
        name: "site",
        query: { device: this.deviceData.device },
      });
    },
    getLeft() {
      return this.drawer
        ? this.heddinList
          ? "567px"
          : "324px"
        : this.heddinList
        ? "243px"
        : "0px";
    },
    initIcons() {
      return [
        {
          name: "温度",
          permi: "map:temperature",
          dataFunc: { color: (v) => this.getColorByValue(v, tem) },
          url: require("@/assets/markers/tem.png"),
          activeUrl: require("@/assets/markers/tem-a.png"),
          legendLabel: "温度(°C)",
          legendColors: tem,
        },
        {
          name: "湿度",
          permi: "map:humidity",
          dataFunc: { color: (v) => this.getColorByValue(v, rhu) },
          url: require("@/assets/markers/hum.png"),
          activeUrl: require("@/assets/markers/hum-a.png"),
          legendLabel: "湿度(%)",
          legendColors: rhu,
        },
        {
          name: "风力",
          permi: "map:windpower",
          dataFunc: { color: (v) => this.getColorByValue(v, wind) },
          url: require("@/assets/markers/wind.png"),
          activeUrl: require("@/assets/markers/wind-a.png"),
          legendLabel: "风力(级)",
          legendColors: wind,
        },
        {
          name: "风向",
          permi: "map:winddirection",
          dataFunc: { color: (v) => (v ? "#83ef12" : "#fff") },
          url: require("@/assets/markers/v.png"),
          activeUrl: require("@/assets/markers/v-a.png"),
        },
        {
          name: "小时降雨",
          permi: "map:rainfall",
          dataFunc: { color: (v) => this.getColorByValue(v, pre) },
          url: require("@/assets/markers/pre.png"),
          activeUrl: require("@/assets/markers/pre-a.png"),
          legendLabel: "降水(mm)",
          legendColors: pre,
        },
        {
          name: "日降雨",
          permi: "map:rainfall",
          dataFunc: { color: (v) => this.getColorByValue(v, pre) },
          url: require("@/assets/markers/pre.png"),
          activeUrl: require("@/assets/markers/pre-a.png"),
          legendLabel: "降水(mm)",
          legendColors: pre,
        },
        {
          name: "光照",
          permi: "map:illumination",
          dataFunc: { color: (v) => this.getColorByValue(v, sun) },
          url: require("@/assets/markers/sun.png"),
          activeUrl: require("@/assets/markers/sun-a.png"),
          legendLabel: "光照",
          legendColors: sun,
        },
        {
          name: "uv",
          permi: "map:uv",
          dataFunc: { color: (v) => (v <= 5 ? "#1f68b5" : "#ccc") },
          url: require("@/assets/markers/uv.png"),
          activeUrl: require("@/assets/markers/uv-a.png"),
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
@import "~leaflet/dist/leaflet.css";

// 合并后的侧边栏专用样式
.sidebar-wrapper {
  width: 243px;
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  background: #fff;

  .list-header-tools {
    border-bottom: 1px solid #ebeef5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .tab-list {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      height: 40px;
      padding: 5px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);

      li {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        cursor: pointer;
        font-size: 14px;
        color: #000;
        transition: all 0.3s;

        &.active {
          color: #0395ff;
          font-weight: bold;
        }
        &:not(:last-child) {
          border-right: 1px solid #f2f2f7;
        }
      }
    }

    .filter-controls {
      margin-top: 10px;
      padding: 0 10px;
      .filter-item {
        margin-bottom: 8px;
      }
      .filter-row {
        display: flex;
        margin-bottom: 8px;
        :deep(.el-form-item) {
          flex: 1;
          margin-right: 0;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          gap: 5px;
          .el-form-item__label {
            text-align: left;
            flex-shrink: 0;
            padding: 0;
            font-size: 10px;
            color: #000;
          }
          .el-select {
            flex: 1;
          }
        }
      }
    }
  }

  .list-content {
    flex: 1;
    overflow: hidden;
    position: relative;
    .scroller {
      height: 100%;
      padding: 8px;
    }
    .no-data {
      text-align: center;
      color: #999;
      margin-top: 40px;
    }
  }

  .list_item {
    height: 100px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 12px;
    border: 1px solid #e0eef9;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 5px;
    transition: all 0.2s;
    font-size: 12px;
    color: #333;
    &.offline {
      color: #8e8e93;
    }
    &:hover {
      border-color: #0094ff;
      background: #f0f7ff;
    }

    .dot_online {
      width: 8px;
      height: 8px;
      background: #2cae51;
      border-radius: 50%;
    }
    .dot_offline {
      width: 8px;
      height: 8px;
      background: #d7ded9;
      border-radius: 50%;
    }

    .item-header {
      display: flex;
      align-items: center;
      gap: 4px;
      .device-name {
        flex: 1;
        font-weight: bold;
        font-size: 14px;
      }
      .follow-action {
        cursor: pointer;
        position: relative;
        margin-right: 8px;
        .icon {
          display: inline-block;
          width: 14px;
          height: 12.44px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;

          &.follow-icon {
            background-image: url("~@/assets/markers/heart.png");
          }
          &.unfollow-icon {
            background-image: url("~@/assets/markers/heart-empty.png");
          }
        }
        .count {
          display: inline-block;
          background: #fff;
          position: absolute;
          top: -4px;
          left: 10px;
          font-size: 10px;
          list-style: 1;
          color: #ff5500;
        }
      }
    }
    .item-footer {
      margin-top: 10px;
      display: flex;
      align-items: center;
      gap: 4px;
      color: #000;
    }
  }
}

// GIS 基础样式
.page {
  width: 100%;
  height: calc(100vh - 50px);
  position: relative;
  overflow: hidden;

  .details {
    width: 324px;
  }

  .tab {
    height: 100vh;
    position: absolute;
    background: #fff;
    z-index: 888;
    transition: left 0.3s;
  }
  .show_icon {
    height: 20px;
    position: absolute;
    z-index: 8888;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    img {
      width: 20px;
    }
  }

  .data_list {
    position: absolute;
    border-radius: 10px 0 0 10px;
    top: 48px;
    right: 8px;
    width: 46px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);

    .item {
      width: 100%;
      height: 67px;
      color: #3a3a3c;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      &:first-child {
        border-radius: 10px 0 0 0;
      }
      &:last-child {
        border-radius: 0 0 0 10px;
        border-bottom: none;
      }

      .icon {
        width: 32px;
        height: 32px;
      }
      .name {
        font-size: 12px;
        text-align: center;
      }
      &.selected {
        background: #0091ff;
        color: #fff;
      }
    }
  }

  .mainlist {
    width: 324px;
    display: flex;
    flex-direction: column;
    .header {
      height: 200px;
      background: url("../../assets/gis-personal/bg.png") no-repeat center;
      background-size: cover;
      display: flex;
      align-items: flex-end;
      position: relative;
      .close {
        position: absolute;
        top: 15px;
        right: 15px;
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        font-style: normal;
      }
      .butt {
        padding: 15px;
        width: 100%;
        color: #fff;
        &.online {
          background: rgba(44, 174, 81, 0.8);
        }
        &.offline {
          background: rgba(153, 153, 153, 0.8);
        }
        &.is4g {
          background: rgba(230, 162, 60, 0.8);
        }
        .title {
          font-size: 22px;
          margin: 0;
        }
        .subtitle {
          font-size: 14px;
          margin-top: 5px;
          opacity: 0.9;
        }
        p {
          font-size: 12px;
          margin-top: 5px;
          opacity: 0.8;
        }
      }
    }
    .info {
      padding: 15px;
      background: #f2f2f2;
      &.online {
        background: linear-gradient(180deg, #8263d5 0%, #491cc1 100%);
        color: #fff;
      }
      .update-time {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
      }
      .wendu {
        text-align: center;
        font-size: 40px;
        font-weight: bold;
        margin: 10px 0;
      }
      .more-info {
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .datalist {
      padding: 10px;
      display: grid;
      gap: 10px;
      .postlist {
        background: #fff;
        padding: 10px;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        display: flex;
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          .icon {
            width: 32px;
            height: 32px;
          }
          .val {
            font-size: 16px;
            font-weight: bold;
            margin: 5px 0;
          }
          .name {
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
  }

  .sebiao {
    background: #fff;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    right: 80px;
    bottom: 20px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 500px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    .sebiao-header {
      .sebiao-title {
        font-size: 14px;
        font-weight: bold;
        color: #1181e5;
      }
    }
    .sebiao-body {
      display: flex;
      .sebiao-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        .color-bar {
          height: 12px;
          width: 100%;
        }
        .scope-text {
          font-size: 11px;
          margin-top: 4px;
        }
      }
    }
  }
}

// Marker 样式
:deep(.custom-div-marker) {
  .div-marker-wrapper {
    display: flex;
    align-items: center;
    width: 64px;
    border-radius: 100px 100px 0 100px;
    color: #000;
    position: relative;
    &:has(.icon) {
      border-radius: 100px;
    }
    .icon {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 20px;
      height: 20px;
      background-size: contain;
      &.my-mark {
        background-image: url("~@/assets/markers/mine.png");
      }
      &.follow-mark {
        background-image: url("~@/assets/markers/follow.png");
      }
    }
    .marker-type-icon {
      width: 20px;
      height: 20px;
    }
    .marker-value {
      flex: 1;
      text-align: center;
      font-size: 12px;
      font-weight: 900;
      white-space: nowrap;
      color: #000;
      -webkit-text-stroke: 0.5px #eaeaea;
    }
  }
  &.offline {
    filter: grayscale(1);
    opacity: 0.7;
  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
